<template>
  <v-app>
    <v-main>
      <the-header></the-header>
      <centered-layout>
        <div class="text-center">
          <h1 class="title mb-4">{{ $t('common.loginRequired') }}</h1>
          <v-btn size="medium" color="primary" depressed @click="handleAuthClick">
            {{ $t('common.login') }}
          </v-btn>
        </div>
      </centered-layout>
    </v-main>
  </v-app>
</template>

<script>
import { ProceedMixin } from '@lib/vue-playrix-auth/mixins';
import TheHeader from '@/components/common/TheHeader.vue';

import CenteredLayout from './layouts/CenteredLayout.vue';

export default {
  metaInfo: {
    title: 'Авторизация',
  },
  methods: {
    handleAuthClick() {
      this.proceedAuth();
    },
  },
  components: { CenteredLayout, TheHeader },
  mixins: [ProceedMixin],
};
</script>
